import { mapActions } from 'vuex'

import createPlayer from 'web-audio-player'
import has from 'lodash/has'
import get from 'lodash/get'
import includes from 'lodash/includes'
import union from 'lodash/union'
import isUndefined from 'lodash/isUndefined'
import split from 'lodash/split'
import compact from 'lodash/compact'
import toString from 'lodash/toString'
import map from 'lodash/map'

import axios from 'axios'
import GTMManager from 'mixins/gtm-manager'

import storage from 'local-storage-fallback'

const config = require('config/config')

export default {
  data() {
    return {
      defaultTermId: 325163, // default tid: Abacus
      defaultSectionName: 'Best of abacus',
    }
  },
  mounted() {
    // Some browser may not support this
    // so wrap it with a try catch block
    try {
      if (!has(this, '$root.audio1')) {
        this.$root.audio1 = false
        const audio1 = createPlayer('/static/sounds/littlerobotsoundfactory-03.mp3', {
          buffer: true,
        })
        audio1.on('load', () => {
          this.$root.audio1 = audio1
          if (!has(this, '$root.audio2')) {
            this.$root.audio2 = false
            const audio2 = createPlayer('/static/sounds/littlerobotsoundfactory-01.mp3', {
              buffer: true,
              context: this.$root.audio1.context,
            })
            audio2.on('load', () => {
              this.$root.audio2 = audio2
            })
          }
        })
      }
    } catch (e) {
      console.log(e)
      console.log('Browser do not support web audio player.')
    }
  },
  methods: {
    ...mapActions(['toggleNewsletter']),
    validateEmail(email) {
      const checking = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return checking.test(email)
    },
    play1() {
      if (this.$root.audio1) {
        try {
          this.$root.audio1.play()
          this.$root.audio1.node.connect(this.$root.audio1.context.destination)
        } catch (e) {
          console.log(e)
          console.log('Browser do not support web audio player.')
        }
      }
    },
    play2() {
      if (this.$root.audio2) {
        try {
          this.$root.audio2.play()
          this.$root.audio2.node.connect(this.$root.audio1.context.destination)
        } catch (e) {
          console.log(e)
          console.log('Browser do not support web audio player.')
        }
      }
    },
    subscribeNewsletter(email, section, gtmNewsletterCategory) {
      const endpoint = get(this, '$store.state.settings.NEWSLETTER_API_ENDPOINT')
      const termId = get(section, 'tid', this.defaultTermId)
      const appId = get(config, 'APP_TID')
      const entityType = 'taxonomy_term'
      const sectionName = get(section, 'name', this.defaultSectionName)

      if (email && endpoint && termId && appId) {
        axios.post(`${endpoint}`, {
          email,
          id: termId,
          entity_type: entityType,
          app_id: appId,
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if (response.data.status === 'success') {
            if (gtmNewsletterCategory) {
              this.updateStorageList(termId)

              GTMManager.pushTracker({
                category: gtmNewsletterCategory,
                action: 'Newsletter Sign Up',
                label: sectionName,
              })
            }
            return true
          }
          return false
        })
      }
      return false
    },
    checkSubscribedToList(section) {
      const originalList = this.getOriginalStorageList()
      const termId = get(section, 'tid', this.defaultTermId)

      if (includes(originalList, termId)) {
        this.toggleNewsletter(false)
        return
      }
      this.toggleNewsletter(true)
    },
    getOriginalStorageList() {
      const getStorageData = storage.getItem('nwsltrs_subscribed')
      return !isUndefined(getStorageData) ? compact(map(split(getStorageData, ','), Number)) : [] // convert string to array of Integers with no falsey values
    },
    updateStorageList(appendTermId) {
      const originalList = this.getOriginalStorageList()
      const newList = union(originalList, [appendTermId]) // no duplicate TID
      storage.setItem('nwsltrs_subscribed', toString(newList)) // toString in case cookies is used
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/newsletter.js